module.exports = __webpack_public_path__ + "static/media/status.00e4a337.png";